'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SuitcaseStickersIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.75 5.75V4.75C6.75 4.15 7.15 3.75 7.75 3.75H16.25C16.85 3.75 17.25 4.15 17.25 4.75V5.75M20.15 20.15H3.75C3.15 20.15 2.75 19.75 2.75 19.15V7.45H21.25V19.25C21.15 19.75 20.75 20.15 20.15 20.15Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.5 17C16.7402 17 17.7695 16.0969 17.9661 14.9125C18.0096 14.6509 17.8946 14.3947 17.7071 14.2071L15.7929 12.2929C15.6054 12.1054 15.3491 11.9904 15.0875 12.0339C13.9031 12.2305 13 13.2598 13 14.5C13 15.8807 14.1193 17 15.5 17Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.20548 12.8031C6.01658 12.2841 6.28417 11.7102 6.80315 11.5214L9.78863 10.4347C10.3076 10.2458 10.8815 10.5134 11.0703 11.0324L11.4531 12.0841C11.642 12.6031 11.3744 13.1769 10.8555 13.3658L7.86998 14.4524C7.351 14.6413 6.77715 14.3737 6.58826 13.8548L6.20548 12.8031Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpSuitcaseStickersIcon = forwardRef(SuitcaseStickersIcon);

export { VpSuitcaseStickersIcon as default };
